module.exports = __webpack_public_path__ + "static/media/serviciosdigitales.dc4d61c2.jpg";